const MAP = {
  live: ["LIVE", "bg-emerald-950/50 text-emerald-400 border-emerald-800/60", true],
  stale: ["STALE", "bg-amber-950/50 text-amber-400 border-amber-800/60"],
  closed: ["MKT CLOSED", "bg-slate-800/60 text-slate-300 border-slate-700"],
  auth_required: ["AUTH ISSUE", "bg-rose-950/50 text-rose-400 border-rose-800/60"],
  pending: ["PENDING", "bg-cyan-950/40 text-cyan-300 border-cyan-800/50"],
  not_subscribed: ["NOT SUBSCRIBED", "bg-slate-900 text-slate-500 border-slate-800"],
  open: ["MARKET OPEN", "bg-emerald-950/50 text-emerald-400 border-emerald-800/60", true],
  pre_open: ["PRE-OPEN", "bg-cyan-950/40 text-cyan-300 border-cyan-800/50"],
  post_close: ["POST-CLOSE", "bg-slate-800/60 text-slate-300 border-slate-700"],
  connected: ["STREAM UP", "bg-emerald-950/50 text-emerald-400 border-emerald-800/60", true],
  simulated: ["SIMULATED", "bg-violet-950/40 text-violet-300 border-violet-800/50", true],
  reconnecting: ["RECONNECTING", "bg-amber-950/50 text-amber-400 border-amber-800/60"],
  connecting: ["CONNECTING", "bg-amber-950/50 text-amber-400 border-amber-800/60"],
  down: ["STREAM DOWN", "bg-rose-950/50 text-rose-400 border-rose-800/60"],
  authenticated: ["KITE SESSION OK", "bg-emerald-950/50 text-emerald-400 border-emerald-800/60"],
  syncing: ["SYNCING", "bg-cyan-950/40 text-cyan-300 border-cyan-800/50"],
  authenticating: ["AUTHENTICATING", "bg-cyan-950/40 text-cyan-300 border-cyan-800/50"],
  live_only: ["LIVE-ONLY", "bg-rose-950/50 text-rose-400 border-rose-800/60"],
  no_data: ["NO DATA", "bg-slate-900 text-slate-500 border-slate-800"],
  idle: ["IDLE", "bg-slate-900 text-slate-500 border-slate-800"],
  off: ["OFF", "bg-slate-900 text-slate-500 border-slate-800"],
};

export const StatusBadge = ({ status, label, testid }) => {
  const [text, cls, dot] = MAP[status] || [String(status || "—").toUpperCase(), "bg-slate-900 text-slate-400 border-slate-800"];
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded border px-1.5 py-0.5 font-mono text-[10px] font-semibold tracking-wider ${cls}`}
    >
      {dot && <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-current" />}
      {label || text}
    </span>
  );
};
